import { Component, OnInit } from '@angular/core';
import { ModalService, ModalType } from '@onep/ng-uikit-lib/ui/modal';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ForbiddenModalComponent } from '../forbidden-modal/forbidden-modal.component';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'shared-info-forbidden-modal-spawn',
  template: ``,
  styleUrls: [],
})
export class ForbiddenModalSpawnComponent implements OnInit {
  constructor(
    private modalService: ModalService,
    private securityService: OidcSecurityService
  ) {}

  ngOnInit(): void {
    this.modalService
      .show({
        type: ModalType.PopInModal,
        component: ForbiddenModalComponent,
      })
      .closed$.pipe(
        switchMap(() => this.securityService.logoffAndRevokeTokens()),
        catchError((err) => {
          console.error('Unable to revoke token', err);
          return of(null);
        })
      )
      .subscribe(() => {
        this.securityService.authorize();
      });
  }
}
